import styled from 'styled-components';

import getKey from 'lodash/get';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';

import React from 'react';
import { Link } from 'react-router-dom';

import Admin from 'hive-admin/src/components/Admin';

import PageArchive from 'hive-admin/src/components/PageArchive';
// eslint-disable-next-line max-len
import ArchiveTableCards from 'hive-admin/src/components/PageArchiveTable/ArchiveTableCards';

import 'hive-admin/src/components/PageArchiveTable/index.less';

import {
  stringify as stringifyQuery,
  parse as parseQuery,
  // eslint-disable-next-line import/no-extraneous-dependencies
} from 'query-string';
import ArchiveTableRows, {
  ArchiveTableColumnHeaderSortIcon,
} from './ArchiveTableRows';

const ArchiveTableIndexColumnRow = styled.div`
  color: ${({ theme }) => theme.less.disabledColor};
`;

export default class PageArchiveTable extends PageArchive {
  static config = {
    ...PageArchive.config,
    ClassName: 'PageArchiveTable',
  }

  static defaultProps = {
    ...PageArchive.config,

    archiveTableMode: 'rows',
    getArchiveTableMode: props => (
      props.isMobile || props.isTablet
      ? 'cards'
      : props.archiveTableMode
    ),

    rowKey: '_id',

    columns: [{ title: 'ID', path: '_id' }],
    getColumns: (props, columns) => {
      columns = [
        ...(
          columns
          || props.columns
          || []
        ),
      ];
      if (!props.isMobile && !props.isTablet) {
        columns.unshift({
          key: 'index',
          title: '#',
          align: 'right',
          render: (_record, _column, _props, i) => {
            let result = i + 1;
            const value = parseQuery(props.location.search).pagination;
            const [pageSize, page] = (
              value && value.length
                ? value
                : '20-1'
            ).split('-');
            if (page && pageSize) {
              if (page > 1) {
                result += (page - 1) * pageSize;
              }
            }
            return (
              <ArchiveTableIndexColumnRow>
                {result}
              </ArchiveTableIndexColumnRow>
            );
          },
        });
      }
      return (columns
        || props.columns
        || []
      ).map((column) => {
        const parsed = {
          ...(isObject(column) ? column : {}),
          path: !isObject(column)
          ? column
          : column.path,
          title: props.getColumnTitle(column, props),
          key: !isObject(column)
          ? column
          : isUndefined(column.key)
          ? column.path
          : column.key,
        };
        parsed.render = !isObject(column) || !isFunction(column.render)
        ? (text, record) => props.renderValue(
          record,
          parsed,
          props
        )
        : (text, record, index) => column.render(record, column, props, index);
        return parsed;
      })
    },

    getColumnTitle: (column, props) => {
      const titleString = (
        !isObject(column)
        ? Admin.prettify(column)
        : isUndefined(column.title)
        ? Admin.prettify(column.path)
        : column.title
      );
      if (column.sort && props.getArchiveTableMode(props) === 'rows') {
        const key = column.sort;
        const currentSort = parseQuery(props.location.search).sort;

        const sortUrlValue = (
          currentSort === `${key}Desc`
          ? `${key}Asc`
          : `${key}Desc`
        );

        return (
          <Link
            to={{
              search: stringifyQuery({
                ...parseQuery(props.location.search),
                sort: sortUrlValue,
              }),
            }}
            style={{
              display: 'flex',
              flexDirection: column.align === 'right' ? 'row' : 'row-reverse',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: 'black',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: column.align === 'right' ? 10 : 0,
                marginLeft: column.align === 'right' ? 0 : 10,
              }}
            >
              <ArchiveTableColumnHeaderSortIcon
                active={currentSort === `${key}Desc`}
              >
                ▼
              </ArchiveTableColumnHeaderSortIcon>
              <ArchiveTableColumnHeaderSortIcon
                active={currentSort === `${key}Asc`}
              >
                ▲
              </ArchiveTableColumnHeaderSortIcon>
            </div>
            {titleString}
          </Link>
        );
      }

      return titleString;
    },

    tableProps: {},
    tablePropsRows: {},
    tablePropsCards: {},
    titleColumnPath: 'name',
    getTableProps: (props, mode) => (
        mode === 'rows'
      ? {
          scroll: { x: 'max-content' },
          ...props.tableProps,
          ...props.tablePropsRows,
        }
      : mode === 'cards'
      ? {
          titleColumnPath: props.titleColumnPath,
          subtitleColumnPath: props.subtitleColumnPath,
          ...props.tableProps,
          ...props.tablePropsCards,
        }
      : { ...props.tableProps }
    ),

    transformValue: text => text,
    renderValue: (record, column, props) => {
      const text = (column.transformValue || props.transformValue)(
        getKey(record, column.path),
        record,
        column,
        props,
      );
      if (column.link) {
        const to = column.link.replace(
          /:([^/]+)/g,
          (all, path) => getKey(record, path)
        );
        return <Link to={to}>{text}</Link>;
      }
      return text;
    },
  }

  renderArchiveContentRows() {
    return (
      <ArchiveTableRows
        columns={this.props.getColumns(this.props)}
        dataSource={this.props.data ? this.props.data.data : []}
        size="middle"
        pagination={false}
        rowKey={this.props.rowKey}
        bordered
        style={
          this.props.loading
          ? { pointerEvents: 'none', opacity: 0.4 }
          : undefined
        }
        {...this.props.getTableProps(this.props, 'rows')}
      />
    );
  }

  renderArchiveContentCards() {
    return (
      <ArchiveTableCards
        columns={this.props.getColumns(this.props)}
        dataSource={this.props.data ? this.props.data.data : []}
        rowKey={this.props.rowKey}
        pagination={false}
        style={
          this.props.loading
          ? { pointerEvents: 'none', opacity: 0.4 }
          : undefined
        }
        {...this.props.getTableProps(this.props, 'cards')}
      />
    );
  }

  renderArchiveContent() {
    const mode = this.props.getArchiveTableMode(this.props);
    return (
        mode === 'rows'
      ? this.renderArchiveContentRows(mode)
      : mode === 'cards'
      ? this.renderArchiveContentCards(mode)
      : null
    );
  }
}

Admin.addToLibrary(
  'PageArchiveTable',
  config => PageArchiveTable.create(config),
);
